<h2 mat-dialog-title>
    <div class="dialog-header">
        <div class="dialog-header-titles">
            <span class="title">
                Baixar voucher
            </span>
        </div>
        <button mat-icon-button disableRipple (click)="cancel()">
            <mat-icon disableRipple>close</mat-icon>
        </button>
    </div>
</h2>

<div class="voucher-error-alert" *ngIf="modelSelectionError">
    <mat-icon class="alert-icon">error</mat-icon>
    <span>{{ errorMessage }}</span>
</div>

<div class="voucher-progress-alert" *ngIf="isLoading">
    <mat-icon class="progress-icon">hourglass_top</mat-icon>
    <div class="progress-content">
        <span>Estamos gerando seu(s) voucher(s), isso pode levar alguns segundos...</span>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<mat-dialog-content class="mat-typography">
    <div *ngIf="statusInactive === null" class="inactive-voucher voucher-checking">
        Verificando disponibilidade do voucher...
    </div>


    <ng-container *ngIf="statusInactive !== null">
        <ng-container *ngIf="!statusInactive; else voucherincatvive">

            <h2>Escolha o modelo de voucher desejado</h2>

            <section class="d-flex flex-column">
                <mat-checkbox color="primary" class="label-check-radio" [(ngModel)]="a4Selected"
                    (ngModelChange)="onCheckboxChange()">
                    Voucher para impressão - PDF A4
                </mat-checkbox>
                <mat-checkbox color="primary" class="label-check-radio" [(ngModel)]="mobileSelected"
                    (ngModelChange)="onCheckboxChange()">
                    Voucher para dispositivos móveis
                </mat-checkbox>
            </section>

            <h2 class="mt-4">Escolha se deseja exibir valores</h2>

            <mat-radio-group [(ngModel)]="showValues" aria-label="Select an option" class="d-flex flex-column">
                <mat-radio-button color="primary" class="label-check-radio" [value]="true">
                    Exibir valores no voucher
                </mat-radio-button>
                <mat-radio-button color="primary" class="label-check-radio" [value]="false">
                    Não exibir valores no voucher
                </mat-radio-button>
            </mat-radio-group>
        </ng-container>

        <ng-template #voucherincatvive>
            <div class="inactive-voucher">
                O voucher ainda não está disponível para esta venda. Tente novamente mais tarde.
            </div>
        </ng-template>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="mt-4" [ngClass]="{end: (statusInactive || statusInactive === null)}">
    <button mat-stroked-button color="primary" class="button-action" (click)="cancel()" [disabled]="isLoading">
        CANCELAR
    </button>
    <button mat-flat-button color="primary" class="button-action" (click)="download()" [disabled]="isLoading"
        *ngIf="statusInactive === false">
        BAIXAR VOUCHER EM PDF
    </button>
</mat-dialog-actions>